import { render, staticRenderFns } from "./ProductPricing.vue?vue&type=template&id=6c8f765e&scoped=true&"
import script from "./ProductPricing.vue?vue&type=script&lang=js&"
export * from "./ProductPricing.vue?vue&type=script&lang=js&"
import style0 from "./ProductPricing.vue?vue&type=style&index=0&id=6c8f765e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f765e",
  null
  
)

export default component.exports